import { IAppState } from '../../common/state';
import { getRegionId } from '../../utils/geo';

export const selectRegionId = (state: IAppState): number => {
  return getRegionId(state.filters.currentLocation);
};
